<div class="cell shrink sessionLocked">
    <div class="sessionLocked-img"></div>
    <h2 class="sessionLocked-title"[i18nKey]="'session.locked.title'"></h2>

    <p class="sessionLocked-text"><span [i18nKey]="'session.locked.message.part1'"></span> <br /> <span [i18nKey]="'session.locked.message.part2'"></span></p>
</div>

